<template>
<svg viewBox="0 0 104 104" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" overflow="visible">
  <ellipse cx="52" cy="52" rx="51.95" ry="51.5" stroke="currentColor" :fill="fill" vector-effect="non-scaling-stroke" /><!-- shape-rendering=crispEdges />-->
</svg>
</template>

<script>
export default {
  props: {
    fill: { type: String, default: 'none' }
  }
}
</script>

<style scoped>
ellipse{
  stroke-width:1px;
}
@media (--bkpt-xl) {
  ellipse{
    stroke-width:0.05vw;
  }
}
</style>
